<template>
  <div>
    <div>
      <a-input addon-before="终端ID："  style="width: 590px" default-value="" v-model="id"/>
    </div>
    <a-select default-value="1" style="width: 120px" @change="handleChange">
      <a-select-option value="1">
        试用
      </a-select-option>
      <a-select-option value="0">
        永久
      </a-select-option>
    </a-select>
    <a-input placeholder="激活码" disabled="true" style="width:400px" v-model="activecode"/>
    <a-button type="primary" @click = "getactive">
      获取
    </a-button>
    
  </div>
  
</template>
<script>
export default {
    data(){
        
        return {
            selected:1,
            activecode:""
        };
    },
  methods: {
    handleChange(value) {
        this.selected = value
      console.log(`selected ${value}`);
    },
    
    getactive(){
        let param = {
              sn:this.id,
              type:this.selected
            }
           
              
        let obj = this.$qs.stringify(param)
            this.$axios({
                method:'post',
                url:'/api/terminal/getldh12active',
                data: obj
            }).then((response) =>{          //这里使用了ES6的语法
              let result = response.data
              if(result["result"])
              {
                this.activecode = result["message"]
              }

                console.log(response)       //请求成功返回的数据
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
                
            })
        },
   
  }
}
</script>
<style scoped>
    .backbtn{
        margin-top: 50px;
    }
</style>





// WEBPACK FOOTER //
// src/components/Ldh12active.vue